<script lang="ts" setup>
import noListingImg from '@/assets/img/no-listing-placeholder.svg';
import { ComplateProfileDialog } from '@/components';
import { AppButton, AppFormCard, AppTypography } from '@/components/base';
import { useAuthStore } from '@/modules/auth/store/auth';

const props = withDefaults(
  defineProps<{
    title?: string;
    subtitle?: string;
  }>(),
  {
    title: 'Looking for a support worker?',
    subtitle: 'Please complete your profile to create a job listing or to search Support Worker profiles.',
  }
);

const showVerification = ref(false);
const showJobForm = ref(false);
const { isFullyVerified } = useAuthStore();

const emit = defineEmits<{
  (e: 'handleJobForm', value: boolean): void;
}>();

const create = (): void => {
  if (!isFullyVerified) {
    toggleVerification(true);
  } else {
    navigateTo('/createJobForm');
  }
};

const toggleVerification = (bool?: boolean): void => {
  showVerification.value = bool === undefined ? !showVerification.value : bool;
};
</script>
<template>
  <div v-if="!showJobForm">
    <AppFormCard v-if="!isFullyVerified" :no-shadow="false" :no-gutter="true" class="no-listing-card mt-4">
      <div class="d-flex justify-space-between py-2">
        <div>
          <AppTypography type="headline-1" class="mb-1">{{ title }}</AppTypography>
          <AppTypography type="subheadline-2" class="mb-2">{{ subtitle }}</AppTypography>
          <AppButton size="small" to="/my-profile/profile-info" variant="outlined" class="no-listing-card__create" >
            Complete Profile <v-icon size="20" icon="mdi-chevron-right"
          /></AppButton>
        </div>
        <v-img width="102" height="107" max-width="102" :src="noListingImg" />
      </div>
    </AppFormCard>
    <ComplateProfileDialog v-model="showVerification" />
  </div>
</template>
<style lang="scss" scoped>
.no-listing-card {
  background: #ebfbd1;

  :deep(.v-btn) {
    min-height: 35px;

    .v-btn__content {
      font-weight: 400;
      text-transform: none;
    }
  }
}
</style>
